import React from "react";
import { LoginModal } from "../modals/LoginModal";
import { MODAL_TYPES, ModalType } from "../../constants";
import { BilletYardOperator } from "../../models";

interface LoginModalWrapperProps {
  isLoggedIn: boolean;
  shouldBypassCraneSelection: boolean;
  selectedCraneId: number | null;
  selectedOperatorId: number | null;
  isTouchMode: boolean;
  showTouchKeypad: boolean;
  canManageCranes: boolean;
  isModalOpen: (modalType: ModalType) => boolean;
  onOpenCraneSelection: () => void;
  onTouchLoginSuccess: (operatorCode: string) => void;
  onTouchKeypadClose: () => void;
  onCraneSelect: (craneId: number | null) => void;
  onOperatorSelect: (operator: BilletYardOperator | null) => void;
  onCloseCraneSelection: () => void;
}

export const LoginModalWrapper = ({
  isLoggedIn,
  shouldBypassCraneSelection,
  selectedCraneId,
  selectedOperatorId,
  isTouchMode,
  showTouchKeypad,
  canManageCranes,
  isModalOpen,
  onOpenCraneSelection,
  onTouchLoginSuccess,
  onTouchKeypadClose,
  onCraneSelect,
  onOperatorSelect,
  onCloseCraneSelection,
}: LoginModalWrapperProps) => {
  return (
    <LoginModal
      isLoggedIn={isLoggedIn}
      shouldBypassCraneSelection={shouldBypassCraneSelection}
      selectedCraneId={selectedCraneId}
      selectedOperatorId={selectedOperatorId}
      isTouchMode={isTouchMode}
      onOpenCraneSelection={onOpenCraneSelection}
      onTouchLoginSuccess={onTouchLoginSuccess}
      onTouchKeypadClose={onTouchKeypadClose}
      onCraneSelect={onCraneSelect}
      onOperatorSelect={onOperatorSelect}
      showTouchKeypad={showTouchKeypad}
      showCraneSelection={
        isModalOpen(MODAL_TYPES.CRANE_SELECTION) && canManageCranes
      }
      onCloseCraneSelection={onCloseCraneSelection}
    />
  );
};
